import { withProtectedRoute, roles } from 'lib/auth'
import { AccountDetailsWrapper } from './account-details'

export default withProtectedRoute(AccountDetailsWrapper, roles.COACH)
